<template>
<div>
  <div class="pt-60 pb-20 fs-26 bold">{{info.moduleTitle}}</div>
  <div class="tab-mol carousel-mol">
    <el-carousel height="260px" indicator-position="none" :autoplay="false" :arrow="dataList.length > 1 ? 'hover' : 'never'" :loop="false">
      <el-carousel-item v-for="(item, i) in dataList" :key="i">
        <ul class="p-type-list a-list-1">
          <li v-for="(o, j) in item" :key="j">
            <div class="img-icon" @click="toConnection(o.connection)">
              <img :src="o.pictureUrl" v-if="o.pictureUrl"/>
            </div>
          </li>
        </ul>
      </el-carousel-item>
    </el-carousel>
  </div>
</div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    let pictureInfoList = this.info.extra ? this.info.extra.pictureInfoList : []
    let dataList = [];
    if (pictureInfoList.length) {
      dataList = _.chunk(pictureInfoList, 3)
    }
    return {
      dataList
    }
  },
  mounted () {
  },
  methods: {
    toConnection (url) {
      if (!url) {
        return ''
      }
      window.open(url)
    }
  }
}
</script>
